export default "__VITE_ASSET__DG$lIWxC__"